module.exports = __webpack_public_path__ + "img/compare-history-th-sort-icon.ff6ef6f1.svg";